import { ButtonThemePalette } from '../Button.types';

export const getLinearGradient = ({ button }: ButtonThemePalette): string => `
  background: linear-gradient(90deg,
    ${button.background.primary.base} 0%,
    ${button.background.primary.hover} 100%
  );
`;
